'use strict';

export default {
	DYNAMIC_POS_VIEW: 'Dynamic Pos View',
	FETCHING: 'Loading',
	PRODUCT_SPLIT: 'Product Split',
	HOURLY: 'Hourly Averages And Totals'
};